/**
 * Skeleton loader — shimmering placeholder used instead of spinners.
 *
 * <Skeleton className="h-6 w-32" />
 * <SkeletonBlock rows={3} />
 */
export function Skeleton({ className = "", "data-testid": testId }) {
  return (
    <div
      role="status"
      aria-busy="true"
      data-testid={testId}
      className={"animate-pulse rounded-md bg-secondary/60 " + className}
    />
  );
}

export function SkeletonBlock({ rows = 3, className = "" }) {
  return (
    <div className={"space-y-2 " + className}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className={"h-4 " + (i === 0 ? "w-3/4" : i === rows - 1 ? "w-1/2" : "w-full")} />
      ))}
    </div>
  );
}

export function SkeletonCard({ className = "" }) {
  return (
    <div className={"rounded-xl border border-border bg-card p-4 " + className}>
      <div className="flex items-center gap-3">
        <Skeleton className="h-9 w-9 rounded-full" />
        <div className="flex-1">
          <Skeleton className="mb-1.5 h-3 w-24" />
          <Skeleton className="h-6 w-20" />
        </div>
      </div>
    </div>
  );
}
